// Utility layer (TS-2.5.04) - pure, no side effects. A per-product status rollup: how many of this
// product's projects sit at each status value, so the Product view can show a strip of chips beside
// each product heading rather than making a reader count rows. Grouped by StatusView.canonical
// (the resolved vocabulary label already on ProjectSummary) rather than by rawValue, the same
// resolved-not-raw choice ProjectsTable makes for its own status pill.
import type { ProjectSummary } from "../../../api/generated/contracts";

export interface StatusRollupEntry {
  readonly canonical: string;
  readonly colorHex: string;
  readonly count: number;
}

export function statusRollup(projects: readonly ProjectSummary[]): readonly StatusRollupEntry[] {
  const byStatus = new Map<string, StatusRollupEntry>();

  for (const project of projects) {
    const existing = byStatus.get(project.status.canonical);
    if (existing) {
      byStatus.set(project.status.canonical, { ...existing, count: existing.count + 1 });
    } else {
      byStatus.set(project.status.canonical, {
        canonical: project.status.canonical,
        colorHex: project.status.colorHex,
        count: 1,
      });
    }
  }

  return [...byStatus.values()].sort((a, b) => a.canonical.localeCompare(b.canonical));
}
